import { isEmpty } from 'lodash-es'

export default (path) => {
  if (isEmpty(path)) {
    return ''
  }

  const pathArray = path.split('/')

  if (pathArray[0] === '') {
    pathArray.shift() // remove the empty one
  }

  if (pathArray.length === 0) {
    return ''
  }

  let bodyClass = ''
  if (
    pathArray.length === 1 ||
    pathArray[1] === 'filter' || // ignore filter
    pathArray[1].match('\\w*-\\w*-\\w*-\\w*-\\w*') || // ignore uuid
    pathArray[1].match('\\d+') // ignore object ids
  ) {
    ;[bodyClass] = pathArray
  } else {
    bodyClass = `${pathArray[0]}-${pathArray[1]}`
  }

  return `react-${bodyClass}`
}
